export enum UserQueries {
  Profile = 'profile',
  Permissions = 'permissions',
}
